import { AnimatedVideo } from '@/components/AniamtedVideo';
import './styles.scss';

export const VideoSection = () => {
  return (
    <section className='video-section'>
      <div className='container'>
        <AnimatedVideo src='promo.mp4' className='video' />
      </div>
    </section>
  );
};
